import React from 'react';
import PropTypes from 'prop-types';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useLocation } from 'react-router-dom';
import get from 'lodash/get';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { format } from 'date-fns';
import Tooltip from '@mui/material/Tooltip';
import formatMoney from '../../utils/formatMoney';
import useStyles from '../../utils/useStyles';
import './styles.css';

const PaymentSuccessHeader = (props) => {
  const styles = useStyles();
  const {
    isPrinting,
    invoiceTitle,
    invoiceNumber,
    transactionAmount,
    transactionDate,
  } = props;

  const location = useLocation();
  const transactionPayload = get(location, 'state.transactionRequest', '0');
  const surchargeLabel = get(location, 'state.surchargeLabel') || 'Convenience Fee';

  const surchargeAmount = transactionPayload[0].surcharge_amount;
  const subtotalAmount = transactionPayload[0].subtotal_amount;

  return (
    <>
      <div className="payment-accepted-header">
        <div className="payment-success-header-icons">
          {!isPrinting && (
            <>
              <AttachMoneyIcon className="money-paid-dollar-icon" />
              <CheckCircleRoundedIcon className="money-paid-check-icon" />
            </>
          )}
        </div>
        <div className="merchant-header-invoice-info">
          <Tooltip
            slotProps={{ tooltip: { sx: styles.tooltip } }}
            placement="right-end"
            title={invoiceTitle}
          >
            <div className="invoice-banner-text-one">{invoiceTitle}</div>
          </Tooltip>
          <div className="invoice-banner-text-two">Payment Accepted</div>
          <div className="merchant-header-invoice-number">
            <Tooltip
              slotProps={{ tooltip: { sx: styles.tooltip } }}
              placement="right-end"
              title={invoiceNumber ? `#${invoiceNumber}` : ''}
            >
              <div className="invoice-banner-text-pound">{invoiceNumber ? `#${invoiceNumber}` : '  '}</div>
            </Tooltip>
          </div>
        </div>
      </div>
      <div className="payment-status-main-header">
        <div>
          <div>
            <div className="payment-status-sub-header-text-label">Subtotal</div>
            <div className="payment-status-sub-header-text">
              {formatMoney(subtotalAmount)}
            </div>
            <div className="payment-status-sub-header-text-label">{surchargeLabel}</div>
            <div className="payment-status-sub-header-text">
              {formatMoney(surchargeAmount)}
            </div>
            <div className="payment-status-sub-header-text-label">Total Amount Paid</div>
            <div className="payment-status-sub-header-text">
              {formatMoney(transactionAmount)}
            </div>
          </div>
        </div>
        <div>
          <div>
            <div className="payment-status-main-header-text-label">Payment Date</div>
            <div className="payment-status-main-header-text">
              {format(new Date(transactionDate), 'M/dd/yy')}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

PaymentSuccessHeader.propTypes = {
  invoiceTitle: PropTypes.string.isRequired,
  invoiceNumber: PropTypes.string.isRequired,
  transactionDate: PropTypes.string.isRequired,
  transactionAmount: PropTypes.string.isRequired,
  isPrinting: PropTypes.bool.isRequired,
};

export default PaymentSuccessHeader;
